CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
CustomFieldItem = require 'app/scripts/models/custom-field-item'

class CustomFieldItemList extends CollectionWithHelpers
  model: CustomFieldItem

module.exports = CustomFieldItemList
